



















































































import { Button, Toggle, MDInput } from "@micad/vue-components";
import { defineComponent, onMounted, reactive } from "@vue/composition-api";
import { displayRequestStatus } from "@/notifications";
import { userSelfRegister } from "@/data/repos/selfRegister";
import router from "@/router";

export default defineComponent({
  components: {
    MDInput,
    Toggle,
    Button,
  },
  setup() {
    const query = router.currentRoute.query;
    async function onSubmit(
      userName: string,
      firstName: string,
      lastName: string,
      clientKey: string
    ) {
      const response = await userSelfRegister({
        userName,
        firstName,
        lastName,
        clientKey,
        originalUrl: router.currentRoute.query.originalUrl,
      });
      displayRequestStatus(response);
      if (response.ok) state.finished = true;
    }
    const state = reactive({
      finished: false,
      userName: "",
      firstName: "",
      lastName: "",
      clientKey: query.clientKey || "",
      onSubmit,
    });
    onMounted(() =>
      (
        window.document.getElementById("userName") || { focus: () => null }
      ).focus()
    );
    return state;
  },
});
